var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphicEq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_1446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 18C8.55 18 9 17.55 9 17V7C9 6.45 8.55 6 8 6C7.45 6 7 6.45 7 7V17C7 17.55 7.45 18 8 18ZM12 22C12.55 22 13 21.55 13 21V3C13 2.45 12.55 2 12 2C11.45 2 11 2.45 11 3V21C11 21.55 11.45 22 12 22ZM4 14C4.55 14 5 13.55 5 13V11C5 10.45 4.55 10 4 10C3.45 10 3 10.45 3 11V13C3 13.55 3.45 14 4 14ZM16 18C16.55 18 17 17.55 17 17V7C17 6.45 16.55 6 16 6C15.45 6 15 6.45 15 7V17C15 17.55 15.45 18 16 18ZM19 11V13C19 13.55 19.45 14 20 14C20.55 14 21 13.55 21 13V11C21 10.45 20.55 10 20 10C19.45 10 19 10.45 19 11Z",
    fill: "#C1CACE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_1446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicEq);
export default __webpack_public_path__ + "static/media/graphic_eq.774ebc3f74e54f77a2110cf1459ad1d8.svg";
export { ForwardRef as ReactComponent };